module.exports = __webpack_public_path__ + "media/images/pic/karol-gulatowski-c6d291358286652d1e09b68f13877eec.png";